import React, { useEffect } from 'react';
import cn from 'classnames';
import moment from 'moment';
import Task from '../../Task/Task';
import TaskWithPopover from '../../TaskWithPopover/TaskWithPopover';
import { TASKS_CONTAINER } from '../../../constants/common';
import { states } from '../../../constants/states';
import useCellClickHandlers from '../../../hooks/useCellClickHandlers';
import { containerIds } from '../../../constants/containerIds';
import { useCalendarState } from '../../../context/CalendarContext';
import styles from '../CalendarGrid.module.scss';
import commonStyles from '../../../Calendar.module.scss';

const AgendaView = () => {
  const { calendarData, localTask, state } = useCalendarState();

  const { handleAgendaCellClick } = useCellClickHandlers();

  // scroll to top
  useEffect(() => {
    if (!localTask) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  }, []);

  return calendarData.map((item, index) => {
    const taskArray =
      localTask && item.day.isSame(moment(localTask.fromDate), 'day')
        ? [localTask, ...item.tasks]
        : item.tasks;

    const tasks = taskArray.filter((task) => task.visible);
    const daylongTasks = item.daylongTasks
      ? item.daylongTasks.filter((task) => task.visible)
      : [];

    const totalTasks = tasks.concat(daylongTasks);

    return (
      <div
        data-element={TASKS_CONTAINER}
        className={cn(styles.agendaCellWrapper, {
          [styles.borderBottom]: index !== calendarData.length - 1,
        })}
        key={index}
        style={{
          gridColumn: '2/-1',
          gridRow: `${index + 1}/${index + 2}`,
        }}
        onClick={
          state === states.addTask
            ? (e) => handleAgendaCellClick(e, index)
            : undefined
        }
      >
        {totalTasks?.map((task) => {
          return task.withPopover ? (
            <TaskWithPopover
              key={task.requestId}
              task={task}
              style={{ maxHeight: 'max-content', maxWidth: '200px' }}
              getPopupContainer={() =>
                document.getElementById(containerIds.calendarGrid)
              }
            />
          ) : (
            <Task
              key={task.id}
              task={task}
              rootClassName={cn(commonStyles[`checkbox-${task.index}`], 'task')}
              style={{ maxHeight: 'max-content', maxWidth: '200px' }}
              getPopupContainer={() =>
                document.getElementById(containerIds.calendarGrid)
              }
            />
          );
        })}
      </div>
    );
  });
};

export default AgendaView;
